import React from 'react'
import { InputStyle, InputWrapperStyle, Error } from './style'

const Input = ({ error, className, register, rightInfo, ...props }) => {
	return (
		<InputWrapperStyle className={className}>
			<InputStyle ref={register} error={error} {...props} />
			{error && <Error>{error?.message}</Error>}
		</InputWrapperStyle>
	)
}

export default Input
